export default "__VITE_ASSET__y4hR8e1c__"